export const PERMISSION_TYPES = [
  { key: "billing", value: "Billing", narration: "Billing Permissions " },
  { key: "booking", value: "Booking", narration: "Can Make Bookings" },
  {
    key: "userManagement",
    value: "User Management",
    narration: "Management Permissions "
  }
];



// WEBPACK FOOTER //
// ./src/library/constants.js